import Encoding from '@/js/encoding.js'

export default function readFile (file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()
    // 読み込んだファイルの中身を取得する
    reader.readAsArrayBuffer(file)

    // ファイルの中身を取得後に処理を行う
    reader.addEventListener('load', function () {
      const csvBuf = reader.result
      const buf = modifyCsvToArray(csvBuf)
      // const rtn = caterizeFundData(records)
      resolve(buf)
    })
  })
}

function modifyCsvToArray(csvBuf) {
  let array = new Uint8Array(csvBuf)
  // 文字コードを取得
  switch (Encoding.detect(array)) {
    case 'UTF16':
      // 16ビット符号なし整数値配列と見なす
      array = new Uint16Array(csvBuf)
      break
    case 'UTF32':
    // 32ビット符号なし整数値配列と見なす
      array = new Uint32Array(csvBuf)
      break
  }
  // Unicodeの数値配列に変換
  const unicodeArray = Encoding.convert(array, 'UNICODE', 'SJIS')
  // Unicodeの数値配列を文字列に変換
  const buf = Encoding.codeToString(unicodeArray)

  return buf
}